export default __webpack_public_path__ + "static/media/bills.00e0e690.svg";